// User-caused or user-cancelled failures: worth a breadcrumb, not a GlitchTip event.
const EXPECTED_AUTH_CODES = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
  'auth/invalid-email',
  'auth/user-not-found',
  'auth/invalid-credential',
  'auth/wrong-password',
  'auth/email-already-in-use',
  'auth/weak-password',
  'auth/too-many-requests',
  'auth/network-request-failed',
  'auth/web-context-canceled',
  'auth/web-context-already-presented',
])

// The native sign-in plugins (Android Credential Manager, Google/Apple on iOS)
// report a cancel by message only, with no auth code.
export const NATIVE_CANCEL =
  /activity is cancelled by the user|User cancelled the selector|canceled the sign-in flow|AuthorizationError error 1001/
// No Google account on the device, or no Credential Manager at all (no or
// outdated Play services); the user has to pick another method.
const NATIVE_NO_CREDENTIALS =
  /No credentials available|Cannot find a matching credential|doesn't support credential manager/
// One Tap status 28439: Google is cooling the prompt down after the user
// dismissed it repeatedly, or they turned One Tap off. Not retryable from
// the app; the login card already points the user at email.
const NATIVE_ONE_TAP_DISABLED = /\[28439\] User disabled the feature/
// auth/network-request-failed as the Android native bridge reports it: message only.
const NATIVE_NETWORK = /A network error \(such as timeout, interrupted connection or unreachable host\) has occurred/
// iOS Google sign-in when the device won't start ASWebAuthenticationSession
// (Screen Time / MDM restrictions, Guided Access). Not retryable; the login card
// already points the user at email (#591).
const NATIVE_SAFARI_BLOCKED = /Unable to open Safari/
// iOS Apple sign-in's catch-all "unknown" (no Apple ID on the device, Screen
// Time/MDM, a stale Apple ID session). Native Apple logins succeed elsewhere,
// so it's the device, not our entitlement; the login card already points the
// user at email (#576, #646).
const NATIVE_APPLE_UNAVAILABLE = /AuthorizationError error 1000\b/

export function isExpectedAuthError(code: string | undefined, message: string) {
  return (code !== undefined && EXPECTED_AUTH_CODES.has(code)) ||
    NATIVE_CANCEL.test(message) ||
    NATIVE_NO_CREDENTIALS.test(message) ||
    NATIVE_ONE_TAP_DISABLED.test(message) ||
    NATIVE_NETWORK.test(message) ||
    NATIVE_SAFARI_BLOCKED.test(message) ||
    NATIVE_APPLE_UNAVAILABLE.test(message)
}
